import { DefaultToggle } from "../../../../common/components/forms/inputs/toggle/DefaultToggle";
import { IPlannerEventUserModel } from "../models/plannerEventUserModel";
import { usePlannerEventReservationDetailsFlag } from "../hooks/usePlannerEventReservationDetailsFlag";
import styles from "./PlannerEventReservationDetailsFlag.module.scss";

interface IPlannerEventReservationDetailsFlagProps {
  user: IPlannerEventUserModel;
  className?: string;
}

export const PlannerEventReservationDetailsFlag = ({
  user,
  className,
}: IPlannerEventReservationDetailsFlagProps) => {
  const { isFlagged, isSaving, onFlagChange } =
    usePlannerEventReservationDetailsFlag(user);

  return (
    <div className={className}>
      <DefaultToggle
        name="classFlag"
        label="Флаг за този клас"
        standalone
        width="100%"
        checked={isFlagged}
        disabled={isSaving}
        onChange={onFlagChange}
      />
      <p className={styles.hint}>
        Малък знак до името на клиента във всички класове с това име. Вие
        решавате какво означава, например „взел екипировка, която трябва да
        върне“.
      </p>
    </div>
  );
};
